import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import { useDepositosStore } from "../../hooks/useDepositosStore";
import inventario from "../../api/inventario";
import { useTheme } from "@mui/material/styles";

const DialogFinalizar = () => {
  const { finalizarDialogOpen, closeFinalizarDialog, articulosControlados, resetFormulario, resetArticulosControlados } = useStockControlStore();

  // Datos hardcodeados para expo
  const idEmpleado = JSON.parse(localStorage.getItem("idEmpleado")) || 1001; // ID hardcodeado para expo
  const { depositoSeleccionado } = useDepositosStore();

  const [comprobanteGuardado, setComprobanteGuardado] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const handleConfirmar = async () => {
    try {
      // ID de depósito hardcodeado para expo si no hay uno seleccionado
      const idDeposito = depositoSeleccionado?.idDeposito || 2001;

      // Para expo, siempre continuar con datos por defecto
      console.log("Guardando ajuste con:", { idEmpleado, idDeposito });

      const movimientos = articulosControlados.map(a => ({
        idArticulo: a.idArticulo,
        cantidad: a.stockReal,
        stockReal: a.stockReal,
        stockTeorico: a.stockTeorico,
      }));

      const resultado = await inventario.persistirAjustes(idEmpleado, idDeposito, movimientos);

      resetFormulario();
      resetArticulosControlados();

      // Para expo, generar número de comprobante simulado
      const numeroComprobante = `${Date.now().toString().slice(-6)}`;
      setComprobanteGuardado(numeroComprobante);
    } catch (error) {
      console.error("Error al guardar ajuste:", error);
      alert("Error al guardar el ajuste de stock.");
    }
  };

  const handleCerrar = () => {
    setComprobanteGuardado(null);
    closeFinalizarDialog();
    navigate(-1);
  };

  return (
    <Dialog open={finalizarDialogOpen} onClose={handleCerrar}>
      {comprobanteGuardado ? (
        <>
          <DialogTitle>Ajuste guardado</DialogTitle>
          <DialogContent>
            <Typography>El ajuste fue guardado correctamente.</Typography>
            <Typography sx={{ mt: 1, fontWeight: "bold" }}>Comprobante N°: {comprobanteGuardado}</Typography>
          </DialogContent>
          <DialogActions>
            <Button sx={{ backgroundColor: theme.bandera.colorSecundario }} variant="contained" onClick={handleCerrar}>
              Aceptar
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogTitle>Confirmar finalización</DialogTitle>
          <DialogContent>
            <Typography>¿Deseás guardar el ajuste de stock y finalizar?</Typography>
            <Typography sx={{ mt: 2, fontWeight: "bold" }}>Artículos cargados: {articulosControlados.length}</Typography>
          </DialogContent>
          <DialogActions>
            <Button sx={{ color: theme.bandera.colorSecundario }} onClick={closeFinalizarDialog}>
              Cancelar
            </Button>
            <Button sx={{ backgroundColor: theme.bandera.colorSecundario }} variant="contained" onClick={handleConfirmar}>
              Confirmar
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default DialogFinalizar;
